import { render, staticRenderFns } from "./MyInfoDashboardItemSba.vue?vue&type=template&id=a69092a6&scoped=true&"
import script from "./MyInfoDashboardItemSba.vue?vue&type=script&lang=js&"
export * from "./MyInfoDashboardItemSba.vue?vue&type=script&lang=js&"
import style0 from "./MyInfoDashboardItemSba.vue?vue&type=style&index=0&id=a69092a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69092a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VChip,VCol,VDataTable,VIcon,VProgressCircular,VRow})
